// extracted by mini-css-extract-plugin
export default {"map":"contacts_map__-nlcV"};